/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profile-straight': {
    width: 22,
    height: 32,
    viewBox: '0 0 22 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.167 7a5 5 0 1110 0 5 5 0 01-10 0zm5-7a7 7 0 100 14 7 7 0 000-14zM2 27.667C2 24.46 4.381 22 7.154 22h7.692C17.62 22 20 24.46 20 27.667V31a1 1 0 102 0v-3.333C22 23.509 18.871 20 14.846 20H7.154C3.129 20 0 23.51 0 27.667V31a1 1 0 102 0v-3.333z" _fill="#1F222C"/>'
  }
})
